import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { Main } from './components/containers';

const Manifests = () => {
  const { t } = useTranslation('manifestsModule');
  const { setBreadcrumbs, setHeaderActions } = usePageNavigation();

  useEffect(() => {
    setBreadcrumbs([
      { label: t('breadcrumb.order_preparation', 'Preparacion de pedidos'), path: '/order-preparation' },
      { label: t('breadcrumb.manifests', 'Manifiestos') },
    ]);
    setHeaderActions([]);
  }, [setBreadcrumbs, setHeaderActions, t]);

  return <Main />;
};

export default Manifests;
